<template>
  <Login />
</template>

<script setup>
import Login from '@/sections/account/login/Login.vue';
</script>
